import { memo } from "react";
import { Skeleton } from "src/components";
import { BoldText, RegularText } from "src/components/v1";
import { createStyles } from "src/styles";

const styles = createStyles({
  keyValueRow: {
    marginTop: 8,
    display: "flex",
    flexDirection: "row",
    overflowX: "hidden",
    width: "100%",
    whiteSpace: "nowrap",
  },
  key: {
    marginRight: 8,
  },
  value: {
    overflowX: "hidden",
    textOverflow: "ellipsis",
  },
});

const KeyValue = ({ label, value, loading }: { label: string; value?: string; loading?: boolean }) => (
  <div css={styles.keyValueRow}>
    <BoldText style={styles.key}>{`${label}:`}</BoldText>
    {loading ? <Skeleton width={160} /> : <RegularText style={styles.value}>{value || "N/A"}</RegularText>}
  </div>
);

export default memo(KeyValue);
